export default function (state = {}, action) {
	switch (action.type) {

	case 'FETCH_CONTROL_SUCCESS':
		return action.response

	case 'CONTROL_RECEIVED':
		return action.controlObject


	case 'UPDATE_CONTROL_REQUEST':
		return action.requestData

	case 'UPDATE_CONTROL_SUCCESS':
		return action.response
	
	case 'LOGOUT':
		return {}
	
	default:
		return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/control.js